export default __webpack_public_path__ + "static/media/room2.4f9978bd.jpg";